/**
 * SDK runtime helpers derived from publisher settings (timing, clamps, etc.).
 */
/**
 * `PublisherSettings.delay` is in seconds (legacy `launcher.js` `renderAdWithDelay`).
 * Returns milliseconds for `setTimeout`, clamped to >= 0.
 */
export function getShowDelayMs(settings) {
    if (!settings) {
        return 0;
    }
    const sec = Number(settings.delay ?? 0);
    return Math.max(0, Number.isFinite(sec) ? sec : 0) * 1000;
}
